import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import { store } from './redux/store'; // For named export

import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import './global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </Provider>

);